// src/components/HouseSelector.jsx
import React, { useState } from 'react';
import Modal from './Modal';
import { toast } from './Toast';
import { collection, query, where, getDocs, doc, updateDoc, arrayUnion } from "firebase/firestore";
import { db } from "../lib/firebase";

export default function HouseSelector({ open, onClose, houses, activeHouseId, onSelect, onAdd, onRename, onDelete, user }) {
  const [adding,   setAdding]   = useState(false);
  const [newName,  setNewName]  = useState('');
  const [renaming, setRenaming] = useState(null); // { id, name }

  const handleAdd = async () => {
    if (!newName.trim()) return;
    await onAdd(newName.trim());
    setNewName(''); setAdding(false);
  };

  const handleRename = async () => {
    if (!renaming?.name.trim()) return;
    await onRename(renaming.id, renaming.name);
    setRenaming(null);
  };
  const handleJoin = async () => {
  const code = prompt("🔑 Entrez le code d'invitation :");
  if (!code) return;

  const clean = code.trim();

  try {
    const q = query(
      collection(db, "houses"),
      where("inviteCode", "==", clean)
    );

    const snap = await getDocs(q);

    if (snap.empty) {
      toast("❌ Aucune maison trouvée avec ce code");
      return;
    }

    const houseDoc = snap.docs[0];
    const houseId = houseDoc.id;
    const house = houseDoc.data();

    // 🔥 AJOUT DU USER DANS MEMBERS
    await updateDoc(doc(db, "houses", houseId), {
      members: arrayUnion(user.uid)
    });

    // UI update
    onSelect(houseId);
    onClose();

    toast(`🏠 Maison "${house.name}" rejointe !`);
  } catch (err) {
    console.error(err);
    toast("⚠️ Erreur lors de la jonction");
  }
};

  return (
    <Modal open={open} onClose={onClose} title="🏠 Mes maisons">

      {/* Liste des maisons */}
      <div style={{ display:'flex', flexDirection:'column', gap:8, marginBottom:16 }}>
        {houses.map(h => (
          <div key={h.id} style={{
            background: h.id === activeHouseId ? 'rgba(110,231,183,.08)' : 'var(--surface2)',
            border: `1px solid ${h.id === activeHouseId ? 'var(--accent)' : 'var(--border)'}`,
            borderRadius: 12, padding: '12px 14px',
            display: 'flex', alignItems: 'center', gap: 10,
          }}>
            <span style={{ fontSize: 22 }}>🏠</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontFamily:'Syne,sans-serif', fontWeight:700, fontSize:14, color:'var(--text)' }}>
                {h.name}
              </div>
              {h.id === activeHouseId && (
                <div style={{ fontSize:11, color:'var(--accent)', marginTop:2 }}>● Maison active</div>
              )}
            </div>
            <div style={{ display:'flex', gap:6 }}>
              <button className="dbtn" onClick={() => { onSelect(h.id); onClose(); }} title="Sélectionner">
                {h.id === activeHouseId ? '✅' : '↗️'}
              </button>
              {h?.ownerId === user?.uid && (
              <><button className="dbtn" onClick={() => setRenaming({ id: h.id, name: h.name })} title="Renommer">✏️</button>
                <button className="dbtn" onClick={() => {
                  if (window.confirm(`Supprimer "${h.name}" ? L'inventaire sera perdu.`)) onDelete(h.id);} } title="Supprimer">🗑️</button>
                <button className="dbtn" onClick={async () => {
                  const code = h?.inviteCode;
                  try {
                  if (!code) return;
                  if (navigator.clipboard?.writeText) {
                    await navigator.clipboard.writeText(code);
                  } else {
                    const textArea = document.createElement("textarea");
                    textArea.value = code;
                    document.body.appendChild(textArea);
                    textArea.select();
                    document.execCommand("copy");
                    document.body.removeChild(textArea);
                  }
                    toast("📋 Code copié !");
                  } catch (err) {
                    toast("❌ Impossible de copier");
                  }
                }}
                title="Copier le code">📋</button></>
              )}
            </div>
          </div>
        ))}

        {houses.length === 0 && (
          <div style={{ textAlign:'center', color:'var(--muted)', fontSize:13, padding:'20px 0' }}>
            Aucune maison. Créez-en une ci-dessous.
          </div>
        )}
      </div>

      {/* Ajouter */}
      {adding ? (
        <div className="fgroup">
          <label className="flabel">Nom de la maison</label>
          <input className="finput" placeholder="ex: Maison principale, Appartement…"
            value={newName} onChange={e => setNewName(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleAdd()} autoFocus />
          <div style={{ display:'flex', gap:8, marginTop:8 }}>
            <button className="bsubmit" style={{ flex:1 }} onClick={handleAdd}>Créer</button>
            <button className="bcancel" style={{ flex:1, margin:0 }} onClick={() => { setAdding(false); setNewName(''); }}>Annuler</button>
          </div>
        </div>
      ) : (
        <><button className="bsubmit" onClick={() => setAdding(true)}>＋ Ajouter une maison</button>
        <button className="bsubmit" onClick={handleJoin}>🔑 Rejoindre une maison</button></>
      )}

      {/* Renommer */}
      {renaming && (
        <div className="fgroup" style={{ marginTop:12 }}>
          <label className="flabel">Renommer</label>
          <input className="finput" value={renaming.name}
            onChange={e => setRenaming(r => ({ ...r, name: e.target.value }))}
            onKeyDown={e => e.key === 'Enter' && handleRename()} autoFocus />
          <div style={{ display:'flex', gap:8, marginTop:8 }}>
            <button className="bsubmit" style={{ flex:1 }} onClick={handleRename}>OK</button>
            <button className="bcancel" style={{ flex:1, margin:0 }} onClick={() => setRenaming(null)}>Annuler</button>
          </div>
        </div>
      )}

      <button className="bcancel" onClick={onClose}>Fermer</button>
    </Modal>
  );
}
